import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
};

export const getStatus = createAsyncThunk('/status/get', async () => {

    let res = axios.get('status',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.categories


    
})

export const createStatus = createAsyncThunk('/status/create', async (item) => {

    let res = axios.post('status', item,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      if(data.data.success){
        alert("Status yaratildi")
      }


    
})
export const deleteStatus = createAsyncThunk('/status/delete', async (item) => {

    let res = axios.delete(`status/${item._id}`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      if(data.data.success){
        alert("Status o'chirildi")
      }


    
})
const status = createSlice({
    name: 'status',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      .addCase(getStatus.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getStatus.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getStatus.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createStatus.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      .addCase(deleteStatus.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      }
  });
export const reducer = status.reducer;